import React from "react";
import styled from "styled-components";

const FloatingButton = styled.a`
  position: fixed;
  right: 28px;
  bottom: 28px;
  z-index: 1200;
  background: #25d366;
  color: #fff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.13);
  font-size: 32px;
  transition: background 0.2s, box-shadow 0.2s;
  text-decoration: none;
  border: none;
  cursor: pointer;
  &:hover {
    background: #1ebe5d;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  }
  @media (max-width: 600px) {
    right: 12px;
    bottom: 12px;
    width: 48px;
    height: 48px;
    font-size: 22px;
  }
`;

const WhatsappIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="white" fillOpacity="0.13" />
    <path
      d="M16 6C10.477 6 6 10.477 6 16c0 1.624.43 3.14 1.18 4.46L6 26l5.66-1.16A9.94 9.94 0 0016 26c5.523 0 10-4.477 10-10S21.523 6 16 6zm0 18c-1.49 0-2.88-.37-4.08-1.02l-.29-.16-3.36.69.7-3.27-.18-.3A7.97 7.97 0 018 16c0-4.42 3.58-8 8-8s8 3.58 8 8-3.58 8-8 8zm4.36-5.27c-.24-.12-1.41-.7-1.63-.78-.22-.08-.38-.12-.54.12-.16.24-.62.78-.76.94-.14.16-.28.18-.52.06-.24-.12-1.01-.37-1.92-1.18-.71-.63-1.19-1.41-1.33-1.65-.14-.24-.01-.37.11-.49.12-.12.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.2-.48-.4-.41-.54-.42-.14-.01-.3-.01-.46-.01-.16 0-.42.06-.64.28-.22.22-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.7 2.6 4.12 3.54.58.2 1.03.32 1.38.41.58.15 1.1.13 1.52.08.46-.07 1.41-.58 1.61-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.46-.28z"
      fill="#fff"
    />
  </svg>
);

const WhatsappButton = () => {
  // Substitua pelo seu número com DDI e DDD, sem espaços ou sinais
  const phone = "45920001825";
  const message = encodeURIComponent("Olá! Gostaria de saber mais.");
  const link = `https://wa.me/${phone}?text=${message}`;

  return (
    <FloatingButton
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco no WhatsApp"
    >
      <WhatsappIcon />
    </FloatingButton>
  );
};

export default WhatsappButton;
